//TODO cleanup this file since we don't need a special GTM datalayer
// object. Just populate the datalayer directly since it's intentionally
// agnostic for all vendor integrations.

window.gtm = {

	/* ==========================================================
		required fields in parameters:
			
			gaId
			cookieDomain
			
		This function needs to be called from the header.
	========================================================== */
	initMetrics: function() {
		// Ensure datalayer exists
		window.datalayer = window.datalayer || {};

		try {
			console.log('defining data layer',this);

			zm.listeners.push({
				initView: gtm.initMetrics,
				trackEvent: gtm.trackEvent,
				trackGeneric: gtm.trackGeneric,
				productView: gtm.productView,
				removedItem: gtm.removedItem,
				checkoutEvent: gtm.checkoutOption
			});
		} catch (err) {
			console.error('error itializing datalayer:',err);
		}
	},

	/* ==========================================================
	required fields in parameters:
		
		event
	
	This function needs to be called before each trans.
	========================================================== */
	trackEvent: function(parameters) {
		window.dataLayer.push (parameters);
	},

	/* ==========================================================
	This function sets a generic datalayer.
	========================================================== */
	trackGeneric: function(parameters) {
		window.dataLayer.push (parameters);
	},


	/* ==========================================================
	required fields in parameters:
		
		pageId
		productId
		productName
	========================================================== */
	productView: function(parameters) {
	
		var currencyCode,
			currencySymbol,
			jsonData;

		if(window.dataLayer) {
			for(var i in window.dataLayer) {
				jsonData = window.dataLayer[i];
				if(jsonData.currency && jsonData.currencySymbol) {
					currencyCode = jsonData.currency;
					currencySymbol = jsonData.currencySymbol;
					break;
				}
			}
		}
		//Following logic is extraction the color code and style code from the SKU/ProductId
		var colorCode = '', styleCode = '', colorCodeLength = 3;
		if (parameters.productId && parameters.productId.length > colorCodeLength + 1) {
			styleCode = parameters.productId.slice(0, parameters.productId.length - colorCodeLength);
			colorCode = parameters.productId.slice(parameters.productId.length - colorCodeLength, parameters.productId.length);
		} else {
			styleCode = parameters.productId;
		}
		window.dataLayer.push({
			'event': 'productDetailView',
			'ecommerce': {
				'currencyCode':currencyCode ? currencyCode : null,
				'currencySymbol': currencySymbol ? currencySymbol : null,
				'detail': {
					'actionField': {
						'list': parameters.pageId
					},
					'products': [{
						'id': parameters.productId,
						'sku': parameters.productId,
						'bundleID': parameters.bundleId ? parameters.bundleId:null,
						'productID': parameters.productId ? parameters.productId:null,
						'itemID': parameters.itemId ? parameters.itemId:null,
						'name': parameters.productName,
						'brand': '',
						'category': parameters.categoryId ? parameters.categoryId : "Misc",
						'variant': parameters.definingAttributes ? parameters.definingAttributes : '',
						'price': parameters.price ? parseFloat(parameters.price) : 0,
						'numReviews': parameters.numReviews ? parameters.numReviews : 0,
						'badge': parameters.badgeDescription ? parameters.badgeDescription : null,
						'avgRating': parameters.avgRating ? parameters.avgRating : 0,
						'styleCode': styleCode,
						'colorCode':  colorCode  ? colorCode : parameters.colorCode,
						'colorDescription': parameters.colorDescription ? parameters.colorDescription : ''
					}]
				}
			}
		});

		var productOrigination = parameters.productOrigination ? parameters.productOrigination : 'search';
		if (window.localStorage.getItem('suggestedProductClicked')) {
			productOrigination = 'Suggested search';	
			window.localStorage.removeItem('suggestedProductClicked');
		}
		var pvProduct = {
			'sku': parameters.productId,
			'name': parameters.productName,
			'category': parameters.categoryId ? parameters.categoryId : "Misc",
			'parentId': parameters.parentProductId ? parameters.parentProductId : '',
			'bundlePartNumber': parameters.bundlePartNumber ? parameters.bundlePartNumber : '',
			'productOrigination': productOrigination,
			'seoCategory': parameters.seoCategory ? parameters.seoCategory : ''
		};

		if (parameters.isSearch === true) {
			window.dataLayer.push({
				'event': 'productview',
				'productViewType': parameters.productViewType,
				'searchProductClick': pvProduct
			});
		} else {
			window.dataLayer.push({
				'event': 'productview',
				'productViewType': parameters.productViewType,
				'gridProductClick': pvProduct
			});
		}
	},


	/* ==========================================================
	required fields in parameters:
		
		productId
		productName
		quantity
		unitPrice
	========================================================== */
	removedItem: function(parameters) {
		
		var currencyCode,
			currencySymbol,
			jsonData;

		if(window.dataLayer) {
			for(var i in window.dataLayer) {
				jsonData = window.dataLayer[i];
				if(jsonData.currency && jsonData.currencySymbol) {
					currencyCode = jsonData.currency;
					currencySymbol = jsonData.currencySymbol;
					break;
				}
			}
		}
		
		window.dataLayer.push({
			'event': 'removeFromCart',
			'ecommerce': {
				'currencyCode': parameters.currency ? parameters.currency : null,
				'currencySymbol': currencySymbol ? currencySymbol : null,
				'remove': {
					'products': [{
						'name': parameters.productName,
						'id': parameters.productId,
						'bundleID': parameters.bundleId ? parameters.bundleId : null,
						'productID': parameters.productId ? parameters.productId : null,
						'itemID': parameters.itemId ? parameters.itemId : null,
						'vn': parameters.itemId ? parameters.itemId : null,
						'price': parseFloat(parameters.unitPrice),
						'brand': '',
						'category': parameters.categoryId ? parameters.categoryId : "Misc",
						'variant': parameters.definingAttributes ? parameters.definingAttributes : '',
						'quantity': parameters.quantity,
						'styleCode': parameters.styleCode ? parameters.styleCode : '',
						'colorCode': parameters.colorCode ? parameters.colorCode : '',
						'colorDescription': parameters.colorDescription ? parameters.colorDescription : '',
						'size': parameters.size ? parameters.size : ''
					}]
				}
			}
		});
	},

	/* ==========================================================
		// TODO: VFDP-27308 verify if this is even being used. It seems
		// like it's unused and kept only to duplicate CoreMetrics
		// functionality. I couldn't get it to fire when testing TBL.

		required fields in parameters:
			
			checkoutStep
			event
	========================================================== */
	checkoutOption: function(parameters) {

		window.dataLayer.push({
			'event': 'checkoutOption',
			'ecommerce': {
			    'checkout_option': {
					'actionField': {
						'step': parameters.checkoutStep,
						'option': parameters.event
					}
				}
			}
		});
	}
};
